export const defaultReactSelectStyles = {
    control: (base) => ({
        ...base,
        borderRadius: "0.375rem",
        borderColor: "#E2E8F0",
        backgroundColor: "#ffffff",
        minHeight: "48px",
        boxShadow: "none",
        outline: "none",
    }),
    input: (base) => ({
        ...base,
        outline: "none",
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 16px",
    }),
    placeholder: (base) => ({
        ...base,
        color: "#94A3B8",
        fontSize: "14px",
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: "14px",
        color: "#334155",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (base) => ({
        ...base,
        borderRadius: "0.375rem",
        marginTop: 0,
    }),
    indicatorsContainer: (base) => ({
        ...base,
        outline: "none",
    }),
};
